import React from 'react'
import { Form } from 'react-bootstrap'
import { ErrorMessage } from '@hookform/error-message';
import PropTypes from 'prop-types'

// export const SelectCombobox = ( props, context, lable, name, valueOptions, valueSelected, onChange ) => {
export const SelectCombobox = ( props, context ) => {

    const { 
        label, 
        name, 
        valueOptions, 
        valueSelected = undefined, 
        disabled = false,
        useFormRegister, 
        onChange = () =>{},
        errors = {} } = props;
    
    return ( 
        <Form.Group controlId={ name }>
            <Form.Label>{ label }</Form.Label>
            <Form.Control as="select"
                name={ name }
                size="sm"
                disabled={ disabled }
                value={ valueSelected }
                onChange={ onChange }
                {...useFormRegister}
            >
                <option value="">{context.t('Select an option')}</option>
                { valueOptions && valueOptions.length > 0 ? valueOptions && valueOptions.map( value => {
                    return (
                        <option key={ value.id } value={ value.id} > { value.name } </option>
                    )
                }) : null}
            </Form.Control>
            <ErrorMessage errors={errors} name={name} as={<p className='error-message'/>} />
        </Form.Group>
    )
}

// PropTypes is necesary in order to obtain "context" in main function attribute.
SelectCombobox.contextTypes = {
    t: PropTypes.func
}

export default SelectCombobox;